import { render, staticRenderFns } from "./compensation.vue?vue&type=template&id=568377ad"
import script from "./compensation.vue?vue&type=script&lang=js"
export * from "./compensation.vue?vue&type=script&lang=js"
import style0 from "./compensation.vue?vue&type=style&index=0&id=568377ad&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports